import { Badge } from '@/components/ui/badge'

type RoomForAccountLabel = {
  roomType?: string | null
  account?: { name?: string | null }
}

export function RoomListAccountLabel({ room }: { room: RoomForAccountLabel }) {
  if (room.roomType === 'COMMUNITY') {
    return (
      <Badge
        variant="outline"
        className="text-[10px] uppercase tracking-wide font-bold bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-50 shrink-0"
      >
        Community
      </Badge>
    )
  }
  return <>{room.account?.name || 'No account'}</>
}
